<template>
  <div id="app">
    <el-config-provider :locale="locale">
      <router-view v-slot="{ Component }">
        <keep-alive>
          <component :is="Component"  v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <component :is="Component"  v-if="!$route.meta.keepAlive"/>
      </router-view>
    </el-config-provider>
    <contact-modal />
  </div>
</template>

<script>
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { ElConfigProvider } from 'element-plus'
import ContactModal from '@/components/ContactModal.vue'
export default {
  name: 'App',
  components: {
    ElConfigProvider,
    ContactModal,
  },
  setup() {
    return {
      locale: zhCn,
    }
  }
}
</script>

<style>
*{
  margin:0;
  padding:0;
}
#app {
  margin:0;
  padding:0;
  height: 100%;
  width: 100%;
  /* 不让用户进行框选 */
  user-select: none;
}
.container{
  width: 100%;
  height: 100%;
  background-color: black;
}
img{
  border:0;
  max-width:100%;
  object-fit:contain;
  object-position:center;
}
html,body{
  -webkit-tap-highlight-color: rgba(0,0,0,0)
}

/* 项目 html 根字号被 rem.js 设为 100px，需重置 Element Plus Message 尺寸 */
.el-message {
  box-sizing: border-box !important;
  min-width: 320px !important;
  max-width: 480px !important;
  padding: 10px 16px !important;
  border-radius: 4px !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
}
.el-message .el-message__icon,
.el-message .el-icon {
  width: 16px !important;
  height: 16px !important;
  margin-right: 8px !important;
  font-size: 16px !important;
}
.el-message .el-message__content {
  padding: 0 !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
}
.el-message .el-message__closeBtn {
  font-size: 14px !important;
}
</style>
